// Centralised data-testid constants
export const NAV = {
  brand: 'nav-brand',
  home: 'nav-home',
  products: 'nav-products',
  about: 'nav-about',
  distributors: 'nav-distributors',
  contact: 'nav-contact',
  languageToggle: 'nav-language-toggle',
  mobileMenuBtn: 'nav-mobile-menu-btn',
  mobileMenuClose: 'nav-mobile-menu-close',
};

export const HOME = {
  heroCta: 'home-hero-cta',
  heroExplore: 'home-hero-explore',
  emergentLink: 'home-emergent-link',
  collection: 'home-collection',
  featured: 'home-featured',
  socialFeed: 'home-social-feed',
};

export const PRODUCTS = {
  list: 'products-list',
  card: (slug) => `product-card-${slug}`,
  viewBtn: (slug) => `product-view-btn-${slug}`,
  detail: 'product-detail',
  detailWhatsapp: 'product-detail-whatsapp',
};

export const DISTRIBUTOR = {
  form: 'distributor-form',
  businessName: 'distributor-business-name',
  contactName: 'distributor-contact-name',
  email: 'distributor-email',
  phone: 'distributor-phone',
  country: 'distributor-country',
  city: 'distributor-city',
  businessType: 'distributor-business-type',
  monthlyVolume: 'distributor-monthly-volume',
  message: 'distributor-message',
  submit: 'distributor-submit',
};

export const CONTACT = {
  form: 'contact-form',
  name: 'contact-name',
  email: 'contact-email',
  subject: 'contact-subject',
  message: 'contact-message',
  submit: 'contact-submit',
  whatsapp: 'contact-whatsapp',
  instagram: 'contact-instagram',
  tiktok: 'contact-tiktok',
  emailLink: 'contact-email-link',
};

export const REGISTRATION = {
  form: 'registration-form',
  name: 'registration-name',
  phone: 'registration-phone',
  email: 'registration-email',
  city: 'registration-city',
  currentDistributor: 'registration-current-distributor',
  customerType: 'registration-customer-type',
  mainInterest: 'registration-main-interest',
  knewJelly: 'registration-knew-jelly',
  favoriteProduct: 'registration-favorite-product',
  wouldBuy: 'registration-would-buy',
  businessCity: 'registration-business-city',
  entersRaffle: 'registration-enters-raffle',
  submit: 'registration-submit',
  expoBanner: 'home-expo-banner',
  ctaBtn: 'home-expo-cta',
};

export const ADMIN = {
  loginForm: 'admin-login-form',
  loginPassword: 'admin-login-password',
  loginSubmit: 'admin-login-submit',
  logout: 'admin-logout',
  dashboard: 'admin-dashboard',
  tabDistributors: 'admin-tab-distributors',
  tabRegistrations: 'admin-tab-registrations',
  exportCsv: 'admin-export-csv',
  distributorRow: (id) => `admin-distributor-row-${id}`,
  registrationRow: (id) => `admin-registration-row-${id}`,
  statusSelect: (id) => `admin-status-select-${id}`,
  deleteBtn: (id) => `admin-delete-btn-${id}`,
};

export const WHATSAPP_FLOAT = 'whatsapp-float-btn';
